module.exports = "/assets/data/0bb54f322be00ae191048b62a69cf270-B66.data.json";